import * as Life from '../common/life';
import { Pattern } from '../common/patterns';

export enum ActionType {
  EVOLVE,
  RESET_CLEAR,
  RESET_RANDOMIZE,
  PLACE_PATTERN,
  RESUME_LIFE,
  SET_EVOLVE_RATE,
  SUSPEND_LIFE,
  TOGGLE_CELL,
  TOGGLE_LIFE,
}

interface StoreMessage {
  type: ActionType,
  payload?: any,
}

export type EventHandler = () => any;

export interface LifeEvents {
  [id: string]: EventHandler,
}

export const Messages = {

  evolveLife: (force: boolean) => ({
    type: ActionType.EVOLVE,
    payload: { force },
  }),

  placePattern: (pattern: Pattern) => {
    return {
      type: ActionType.PLACE_PATTERN,
      payload: { pattern },
    };
  },

  resetClear: () => ({
    type: ActionType.RESET_CLEAR,
  }),

  resetRandomized: () => ({
    type: ActionType.RESET_RANDOMIZE,
  }),

  resumeLife: () => ({
    type: ActionType.RESUME_LIFE,
  }),

  setEvolveRate: (rate: number) => ({
    type: ActionType.SET_EVOLVE_RATE,
    payload: { rate },
  }),

  suspendLife: () => ({
    type: ActionType.SUSPEND_LIFE,
  }),

  toggleCell: (x: number, y: number) => ({
    type: ActionType.TOGGLE_CELL,
    payload: {x, y},
  }),

  toggleLife: () => ({
    type: ActionType.TOGGLE_LIFE,
  }),

}

export const game =
  (state = Life.initializeState(), action: StoreMessage) => {

    const pop = state.population;
    const payload = action.payload;
    let newState: Life.GameState = state;

    switch (action.type) {
      case ActionType.EVOLVE:
        if (payload.force || !state.suspended) {

          newState = { ...state,
            population: pop.evolve(),
            suspended: payload.force,
            year: state.year + 1,
          };
        }
        break;

      case ActionType.PLACE_PATTERN:
        newState = { ...state,
          population: pop.place(payload.pattern),
        };
        break;

      case ActionType.RESET_CLEAR:

        newState = { ...state,
          population: Life.Population.empty(pop.WIDTH, pop.HEIGHT),
          suspended: true,
          year: 0,
        };
        break;

      case ActionType.RESET_RANDOMIZE:

        newState = { ...state,
          population: new Life.Population(pop.WIDTH, pop.HEIGHT),
          suspended: true,
          year: 0,
        };
        break;

      case ActionType.RESUME_LIFE:
        newState = { ...state,
          suspended: false,
        };
        break;

      case ActionType.SET_EVOLVE_RATE:
        newState = { ...state,
          rate: payload.rate,
        };
        break;

      case ActionType.SUSPEND_LIFE:
        newState = { ...state,
          suspended: true,
        };
        break;

      case ActionType.TOGGLE_CELL:
        newState = { ...state,
          population: pop.toggleCell(payload.x, payload.y)
        };
        break;

      case ActionType.TOGGLE_LIFE:
        newState = { ...state,
          suspended: !state.suspended,
        };
        break;

      default:
        console.log((typeof action) + " has no specified reducer");
    }

    return newState;
};



// WEBPACK FOOTER //
// ./src/store/life.ts